import $ from 'jquery';
import { validatefields } from './form';

export const timeout = {};
export const binds = () => {
    $('[data-setup]').on('click', function() {
        var $el = $(this),
            $form = $el.closest('.form'),
            target = $el.data('target');

        if (target.indexOf('signUpStep2') !== -1) {
            if (!validatefields($form, true)) {
                return false;
            }
        }
    });
};
